import type { TPlatform } from '@/types/platform.ts';
import { EPlatform } from '@/types/platform.ts';
import { useFlatRes as _useFlatRes } from './hooks/useFlatRes';
import qs from 'qs';
/**
 * 获取URL传参（query部分）的值
 * @param {string} name - 【必填】key，url参数名
 * @param {string} [url] - 【选填】指定查询参数的链接
 * @returns {string|null}
 */
export const getUrlParams = (name: string, url?: string): string | null => {
  let str = window.location.search;
  if (url) {
    const idx = url.indexOf('?');
    if (idx >= 0) {
      // str = url.split('?')[1];
      str = url.substring(idx);
    } else {
      str = url;
    }
  }
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = str.substr(1).match(reg);
  if (r !== null) {
    return decodeURI(r[2]);
  }
  return null;
};

/**
 * 获取URL传参（所有query部分）的值
 * @param {String} [url] - 指定url
 * @return {Object | null}
 */
export const getUrlParamsObj = (url?: string): object | null => {
  let _url = window.location.search;
  if (url) {
    const idx = url.indexOf('?');
    if (idx >= 0) {
      _url = url.substring(idx);
    } else {
      console.warn('getUrlParamsObj: 当前入参不包含search部分');
    }
  }
  const _idx = _url.indexOf('?');
  if (_idx >= 0) {
    _url = _url.substring(_idx + 1);
  }
  if (_url) {
    const paramObj = qs.parse(_url);
    console.log(paramObj, _url);
    return paramObj || null;
  }
  return null;
};

export const wxLogin = () => {
  return new Promise<{ code?: string; errMsg?: string } | any>((resolve, reject) => {
    wx.login({
      success(res: { code?: string; errMsg?: string }) {
        resolve(res);
      },
      fail(err: { errMsg?: string; errno: number }) {
        reject(err);
      },
    });
  });
};

export const wxCrypto = (len = 16) => {
  const userCrypto = wx.getUserCryptoManager();
  return new Promise((resolve, reject) => {
    userCrypto.getRandomValues({
      length: len,
      success(res) {
        resolve(res);
      },
      fail(err) {
        console.log('arraybuffer err: ', err);
        reject(err);
      },
    });
  });
};

export function ceilToNearMin(timestamp) {
  return Math.floor(timestamp / 60000) * 60000;
}
export function timestampToSec(timestamp) {
  return timestamp / 1000;
}
export function formateTimestamp(timestamp) {
  const minceil = ceilToNearMin(timestamp);
  const secTimestamp = timestampToSec(minceil);
  return secTimestamp;
}

/**
 * @description: 将 ArrayBuffer 转换为 16 进制字符串
 */
export const buff2hex = (buffer: ArrayBuffer) => {
  return Array.prototype.map.call(new Uint8Array(buffer), (x) => ('00' + x.toString(16)).slice(-2)).join('');
};

/**
 * @description: 将 ArrayBuffer 转换为 字符串
 * @param buffer
 */
export const buff2Str = (buffer: ArrayBuffer) => {
  let encodedString = String.fromCodePoint.apply(null, new Uint8Array(buffer));
  let decodedString = decodeURIComponent(escape(encodedString)); // 没有这一步中文会乱码
  return decodedString;
};
/**
 * @description: 将 16 进制字符串转换为 字符串
 * @param hex
 */
export const hex2Str = (_hex: string) => {
  const hex = _hex.replace(/^0x/, '').trim();
  let str = '';
  for (let i = 0; i < hex.length; i += 2) {
    // let current = hex.substr(i, 2);
    // while (current.length < 2) current = '0' + current;
    // let charCode = parseInt(current, 16);
    // str += String.fromCharCode(charCode);
    let charCode = parseInt(hex.substr(i, 2), 16);
    str += String.fromCharCode(charCode);
    // str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
  }
  return str;
  // return decodeURIComponent(escape(str));
};

export const str2buff = (str: string) => {
  let arr = new Uint8Array(str.length);
  for (let i = 0, len = str.length; i < len; i++) {
    arr[i] = str.charCodeAt(i);
  }
  return arr.buffer;
};

export const useFlatRes = _useFlatRes;
const basicTool = {
  getUrlParams,
  getUrlParamsObj,
  wxLogin,
  wxCrypto,
  useFlatRes,
  ceilToNearMin,
  timestampToSec,
  formateTimestamp,
  buff2hex,
  buff2Str,
  hex2Str,
  str2buff,
};
export default basicTool;
